(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["azuelos-blush-film"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('azuelos-blush-film')) {
    customElements.define('azuelos-blush-film', class extends HTMLElement {
      connectedCallback() {
        if (this.filmAbort) return;
        this.filmFrames = [...this.querySelectorAll('[data-film-frame]')];
        this.filmCaptions = [...this.querySelectorAll('[data-film-caption]')];
        this.filmIndexes = [...this.querySelectorAll('[data-film-index]')];
        this.filmToggle = this.querySelector('[data-film-toggle]');
        if (!this.filmFrames.length || !this.filmToggle) return;
        this.filmAbort = new AbortController();
        const signal = this.filmAbort.signal;
        this.filmMotion = matchMedia('(prefers-reduced-motion: reduce)');
        this.filmCurrent = 0;
        this.filmPaused = this.filmMotion.matches;
        this.filmVisible = false;
        this.filmFocused = false;
        this.filmHovered = false;
        this.classList.add('is-ready');
        this.showFilmFrame(0);
        this.querySelector('[data-film-controls]').hidden = this.filmFrames.length < 2;
        this.filmIndexes.forEach((button, index) => button.addEventListener('click', () => {
          this.filmPaused = true;
          this.showFilmFrame(index);
          this.syncFilmPlayback();
        }, { signal }));
        this.filmToggle.addEventListener('click', () => {
          this.filmPaused = !this.filmPaused;
          this.syncFilmPlayback();
        }, { signal });
        this.addEventListener('focusin', () => { this.filmFocused = true; this.syncFilmPlayback(); }, { signal });
        this.addEventListener('focusout', event => {
          if (!this.contains(event.relatedTarget)) { this.filmFocused = false; this.syncFilmPlayback(); }
        }, { signal });
        this.addEventListener('pointerenter', event => {
          if (event.pointerType === 'mouse') { this.filmHovered = true; this.syncFilmPlayback(); }
        }, { signal });
        this.addEventListener('pointerleave', () => { this.filmHovered = false; this.syncFilmPlayback(); }, { signal });
        document.addEventListener('visibilitychange', () => this.syncFilmPlayback(), { signal });
        this.filmMotion.addEventListener('change', () => {
          this.filmPaused = true;
          this.syncFilmPlayback();
        }, { signal });
        this.filmObserver = new IntersectionObserver(entries => {
          this.filmVisible = entries[0].isIntersecting && entries[0].intersectionRatio >= 0.15;
          this.syncFilmPlayback();
        }, { threshold: 0.15 });
        this.filmObserver.observe(this);
        this.syncFilmPlayback();
      }
      showFilmFrame(index) {
        this.filmCurrent = index;
        this.filmFrames.forEach((frame, position) => {
          const active = position === index;
          frame.classList.toggle('is-current', active);
          frame.setAttribute('aria-hidden', String(!active));
          this.filmCaptions[position].hidden = !active;
          this.filmIndexes[position].setAttribute('aria-pressed', String(active));
        });
      }
      syncFilmPlayback() {
        clearTimeout(this.filmTimer);
        const reduced = this.filmMotion.matches;
        const paused = this.filmPaused || reduced;
        const stopped = paused || !this.filmVisible || document.hidden || this.filmFocused || this.filmHovered;
        this.classList.toggle('is-reduced', reduced);
        this.classList.toggle('is-paused', paused);
        this.classList.toggle('is-still', stopped);
        this.filmToggle.hidden = reduced;
        this.querySelector('[data-film-toggle-label]').textContent = paused ? this.dataset.resumeLabel : this.dataset.pauseLabel;
        if (!stopped && this.filmFrames.length > 1) {
          this.filmTimer = setTimeout(() => {
            this.showFilmFrame((this.filmCurrent + 1) % this.filmFrames.length);
            this.syncFilmPlayback();
          }, 7000);
        }
      }
      disconnectedCallback() {
        clearTimeout(this.filmTimer);
        this.filmObserver?.disconnect();
        this.filmAbort?.abort();
        this.filmAbort = null;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["azuelos-cinema-film"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('azuelos-cinema-player')){customElements.define('azuelos-cinema-player',class extends HTMLElement{
connectedCallback(){if(this.abort)return;this.abort=new AbortController();const signal=this.abort.signal;this.video=this.querySelector('video');this.control=this.querySelector('button');this.progress=this.querySelector('.az-cinema-player__progress span');this.motion=matchMedia('(prefers-reduced-motion: reduce)');this.mobile=matchMedia('(max-width: 749px)');this.setPoster();if(typeof this.paused!=='boolean')this.paused=false;if(this.motion.matches||navigator.connection?.saveData)this.paused=true;this.visible=false;this.video.controls=false;this.control.hidden=false;this.control.addEventListener('click',()=>{this.paused=!this.video.paused;if(!this.paused)this.loadSource();this.sync()},{signal});this.video.addEventListener('play',()=>this.update(),{signal});this.video.addEventListener('pause',()=>this.update(),{signal});this.video.addEventListener('error',()=>{this.paused=true;this.update()},{signal});this.video.addEventListener('timeupdate',()=>{if(this.video.duration)this.progress.style.transform='scaleX('+this.video.currentTime/this.video.duration+')'},{signal});this.motion.addEventListener('change',()=>{if(this.motion.matches)this.paused=true;this.sync()},{signal});this.mobile.addEventListener('change',()=>{this.setPoster();if(this.loaded){this.loadSource();this.sync()}},{signal});document.addEventListener('visibilitychange',()=>this.sync(),{signal});this.observer=new IntersectionObserver(entries=>{this.visible=entries[0].isIntersecting&&entries[0].intersectionRatio>=.1;if(this.visible&&!this.paused)this.loadSource();this.sync()},{threshold:.1});this.observer.observe(this);this.update()}
setPoster(){this.video.poster=this.mobile.matches?this.dataset.posterMobile:this.dataset.posterDesktop}
loadSource(){const src=this.mobile.matches?this.dataset.mobile:this.dataset.desktop;if(this.video.getAttribute('src')!==src){this.playAttempt=(this.playAttempt||0)+1;this.video.src=src;this.loaded=true;this.video.load()}}
sync(){if(this.paused||!this.visible||document.hidden){this.playAttempt=(this.playAttempt||0)+1;this.video.pause()}else{this.loadSource();if(!this.video.paused)return;const attempt=this.playAttempt=(this.playAttempt||0)+1;const connection=this.abort;this.video.play().catch(error=>{if(error.name==='AbortError'||connection.signal.aborted||attempt!==this.playAttempt)return;this.paused=true;this.update()})}}
update(){const paused=this.video.paused;this.control.querySelector('[data-player-label]').textContent=paused?this.dataset.play:this.dataset.pause;this.control.querySelector('[data-player-icon]').textContent=paused?'▷':'Ⅱ';this.control.setAttribute('aria-pressed',String(!paused))}
disconnectedCallback(){this.playAttempt=(this.playAttempt||0)+1;this.observer?.disconnect();this.abort?.abort();this.abort=null;this.video?.pause()}
})}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["azuelos-cinema-hero"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('azuelos-cinema-cover')){customElements.define('azuelos-cinema-cover',class extends HTMLElement{
connectedCallback(){if(this.abort)return;this.abort=new AbortController();const signal=this.abort.signal;this.control=this.querySelector('button');this.motion=matchMedia('(prefers-reduced-motion: reduce)');if(typeof this.paused!=='boolean')this.paused=false;this.visible=false;this.control.hidden=false;this.control.addEventListener('click',()=>{this.paused=!this.paused;this.sync()},{signal});this.motion.addEventListener('change',()=>this.sync(),{signal});document.addEventListener('visibilitychange',()=>this.sync(),{signal});this.observer=new IntersectionObserver(entries=>{this.visible=entries[0].isIntersecting;this.sync()});this.observer.observe(this);this.sync()}
sync(){const stopped=this.paused||this.motion.matches;this.classList.toggle('is-moving',!stopped&&this.visible&&!document.hidden);this.control.hidden=this.motion.matches;this.control.querySelector('[data-motion-label]').textContent=stopped?this.dataset.play:this.dataset.pause;this.control.querySelector('.az-cinema-motion__icon').textContent=stopped?'▷':'Ⅱ';this.control.setAttribute('aria-pressed',String(!stopped))}
disconnectedCallback(){this.observer?.disconnect();this.abort?.abort();this.abort=null;this.classList.remove('is-moving')}
})}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["azuelos-clip-story"] && !Shopify.designMode) return;
  try {
    (() => {
  const stories = new WeakMap();
  function initClipStory(root) {
    if (root.dataset.azClipInitialized === 'true') return;
    const controls = root.querySelector('[data-az-clip-controls]');
    const buttons = Array.from(root.querySelectorAll('[data-az-clip-button]'));
    const views = Array.from(root.querySelectorAll('[data-az-clip-view]'));
    const status = root.querySelector('[data-az-clip-status]');
    const playButton = root.querySelector('[data-az-clip-play]');
    const playLabel = root.querySelector('[data-az-clip-play-label]');
    if (!controls || !buttons.length || !views.length) return;
    const events = new AbortController();
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const sequence = ['optical', 'attached', 'detached'];
    let selectedKey = 'detached';
    let playing = false;
    let timer = null;
    let visible = true;
    function selectView(key, announce, animate = true) {
      const selected = views.find(view => view.dataset.azClipView === key);
      if (!selected) return;
      selectedKey = key;
      root.dataset.azClipMotion = String(animate && !reducedMotion.matches);
      views.forEach(view => { view.hidden = view !== selected; });
      buttons.forEach(button => {
        button.setAttribute('aria-pressed', String(button.dataset.azClipButton === key));
      });
      if (announce && status) status.textContent = selected.dataset.announcement;
    }
    function syncPlayback() {
      if (!playButton || !playLabel) return;
      playButton.setAttribute('aria-pressed', String(playing));
      playLabel.textContent = playing ? playButton.dataset.pauseLabel : playButton.dataset.playLabel;
    }
    function stop() {
      playing = false;
      if (timer !== null) window.clearTimeout(timer);
      timer = null;
      syncPlayback();
    }
    function scheduleNext() {
      timer = window.setTimeout(() => {
        timer = null;
        if (!playing || !visible || document.hidden || !root.isConnected) {
          stop();
          return;
        }
        const next = (sequence.indexOf(selectedKey) + 1) % sequence.length;
        selectView(sequence[next], false);
        scheduleNext();
      }, 3200);
    }
    function start() {
      if (!visible || document.hidden) return;
      stop();
      playing = true;
      if (status) status.textContent = '';
      selectView('optical', false);
      syncPlayback();
      scheduleNext();
    }
    buttons.forEach(button => {
      button.addEventListener('click', () => {
        stop();
        selectView(button.dataset.azClipButton, true);
      }, { signal: events.signal });
    });
    if (playButton && playLabel && sequence.every(key => views.some(view => view.dataset.azClipView === key))) {
      playButton.addEventListener('click', () => playing ? stop() : start(), { signal: events.signal });
      playButton.hidden = false;
      syncPlayback();
    }
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) stop();
    }, { signal: events.signal });
    reducedMotion.addEventListener('change', () => {
      root.dataset.azClipMotion = 'false';
      stop();
    }, { signal: events.signal });
    const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.target !== root) return;
        visible = entry.isIntersecting && entry.intersectionRatio > 0;
        if (!visible) stop();
      });
    }, { threshold: 0 }) : null;
    observer?.observe(root);
    const initial = buttons.find(button => button.getAttribute('aria-pressed') === 'true');
    selectView(initial ? initial.dataset.azClipButton : 'detached', false, false);
    controls.hidden = false;
    root.dataset.azClipInitialized = 'true';
    stories.set(root, () => {
      stop();
      observer?.disconnect();
      events.abort();
      delete root.dataset.azClipInitialized;
      stories.delete(root);
    });
  }
  function initClipStories(scope) {
    if (scope instanceof Element && scope.matches('[data-az-clip-story]')) initClipStory(scope);
    scope.querySelectorAll('[data-az-clip-story]').forEach(initClipStory);
  }
  initClipStories(document);
  document.addEventListener('shopify:section:load', event => initClipStories(event.target));
  document.addEventListener('shopify:section:unload', event => {
    if (event.target instanceof Element && event.target.matches('[data-az-clip-story]')) stories.get(event.target)?.();
    event.target.querySelectorAll('[data-az-clip-story]').forEach(root => stories.get(root)?.());
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["azuelos-language-options"] && !Shopify.designMode) return;
  try {
    const initializedAzuelosLanguageGroups = new WeakSet();
  const azuelosLanguageObservers = new WeakMap();

  function initializeAzuelosLanguageFlags(root) {
    const groups = [...root.querySelectorAll('[data-az-language-options]')];
    if (root instanceof Element && root.matches('[data-az-language-options]')) groups.unshift(root);
    groups.forEach((group) => {
      const selector = group.parentElement.querySelector('select[name="language_code"]');
      if (!selector) return;
      if (!initializedAzuelosLanguageGroups.has(group)) {
        group.addEventListener('click', (event) => {
          if (!(event.target instanceof Element)) return;
          const button = event.target.closest('[data-az-language]');
          const currentSelector = group.parentElement.querySelector('select[name="language_code"]');
          if (!button || !group.contains(button) || !currentSelector || currentSelector.value === button.dataset.azLanguage) return;
          currentSelector.value = button.dataset.azLanguage;
          group.querySelectorAll('[data-az-language]').forEach((choice) => {
            choice.setAttribute('aria-pressed', String(choice === button));
          });
          currentSelector.dispatchEvent(new Event('change', { bubbles: true }));
        });
        initializedAzuelosLanguageGroups.add(group);
      }
      group.querySelectorAll('[data-az-language]').forEach((choice) => {
        choice.setAttribute('aria-pressed', String(choice.dataset.azLanguage === selector.value));
      });
      group.dataset.initialized = 'true';
      selector.hidden = true;
      group.hidden = false;
      group.parentElement.classList.add('azuelos-language-enhanced');
    });
  }

  function observeAzuelosHeaderLanguages(root) {
    const headerGroup = root instanceof Element
      ? root.closest('#header-group') || root.querySelector('#header-group')
      : root.querySelector('#header-group');
    if (!headerGroup || azuelosLanguageObservers.has(headerGroup)) return;
    const observer = new MutationObserver((records) => {
      const changedRoots = new Set();
      records.forEach((record) => {
        if (record.type === 'childList' || record.target.matches('[data-az-language-options][hidden]')) {
          changedRoots.add(record.target);
        }
      });
      changedRoots.forEach((changedRoot) => initializeAzuelosLanguageFlags(changedRoot));
    });
    observer.observe(headerGroup, { childList: true, subtree: true, attributes: true, attributeFilter: ['hidden'] });
    azuelosLanguageObservers.set(headerGroup, observer);
  }

  function initializeAzuelosHeaderLanguages(root) {
    initializeAzuelosLanguageFlags(root);
    observeAzuelosHeaderLanguages(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAzuelosHeaderLanguages(document), { once: true });
  } else {
    initializeAzuelosHeaderLanguages(document);
  }
  document.addEventListener('shopify:section:load', (event) => initializeAzuelosHeaderLanguages(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('#header-group').forEach((headerGroup) => {
      azuelosLanguageObservers.get(headerGroup)?.disconnect();
      azuelosLanguageObservers.delete(headerGroup);
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["azuelos-percees-campaign"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('azuelos-percees-studio')) {
  customElements.define('azuelos-percees-studio', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized) return;
      this.dataset.initialized = 'true';
      this.tabs = Array.from(this.querySelectorAll('[data-percees-select]'));
      this.panels = Array.from(this.querySelectorAll('[data-percees-panel]'));
      const controls = this.querySelector('[data-percees-tablist]');
      if (!controls || !this.tabs.length) return;
      controls.setAttribute('role', 'tablist');
      this.tabs.forEach((tab) => {
        const selected = tab.classList.contains('is-selected');
        tab.setAttribute('role', 'tab');
        tab.setAttribute('aria-selected', String(selected));
        tab.setAttribute('aria-controls', tab.dataset.perceesControls);
        tab.tabIndex = selected ? 0 : -1;
        const panel = this.panels.find((item) => item.id === tab.dataset.perceesControls);
        if (panel) {
          panel.setAttribute('role', 'tabpanel');
          panel.setAttribute('aria-labelledby', tab.id);
        }
      });
      this.addEventListener('click', (event) => {
        const tab = event.target.closest('[data-percees-select]');
        if (!tab || !this.contains(tab) || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        this.select(tab);
      });
      this.addEventListener('keydown', (event) => {
        const tab = event.target.closest('[data-percees-select]');
        if (!tab || !this.tabs.includes(tab)) return;
        const index = this.tabs.indexOf(tab);
        let next;
        if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
        else if (event.key === 'ArrowLeft') next = (index - 1 + this.tabs.length) % this.tabs.length;
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = this.tabs.length - 1;
        else if (event.key === ' ') next = index;
        else return;
        event.preventDefault();
        this.select(this.tabs[next]);
        this.tabs[next].focus();
      });
    }
    select(activeTab) {
      this.tabs.forEach((tab) => {
        const selected = tab === activeTab;
        tab.classList.toggle('is-selected', selected);
        tab.setAttribute('aria-selected', String(selected));
        tab.tabIndex = selected ? 0 : -1;
      });
      this.panels.forEach((panel) => {
        panel.hidden = panel.id !== activeTab.dataset.perceesControls;
        if (!panel.hidden) {
          const image = panel.querySelector('img');
          if (image) image.loading = 'eager';
        }
      });
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
